import {connect} from '../../app/connect';
import IssuePreviewDetailsTabAttachment from './IssuePreviewDetailsTabAttachment';

import {getThumbnails} from '../../app/selectors';

const mapStateToProps = state => ({
  thumbnails: getThumbnails(state)
});

export default connect(mapStateToProps)(IssuePreviewDetailsTabAttachment);
